import styled from 'styled-components'

import { ButtonProps } from '../../config/types'

const Button = styled.button<ButtonProps>`
  background-image: linear-gradient(-84deg, #ffae00 6%, #57ec51 100%);
  color: #fff;

  cursor: pointer;

  font-size: 0.85em;
  padding: 0.8em 1em;
  border: none;
  border-radius: 5px;
`

export default Button
